type PrioritySortable = {
    id: string | number;
    priority?: unknown;
}

const readPriority = (item: PrioritySortable) => {
    const value = item.priority;
    if (value === undefined || value === null || value === '') return null;

    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
}

const sortById = (first: PrioritySortable, second: PrioritySortable) => {
    const firstNumericId = Number(first.id);
    const secondNumericId = Number(second.id);

    if (Number.isFinite(firstNumericId) && Number.isFinite(secondNumericId)) {
        return firstNumericId - secondNumericId;
    }

    return String(first.id || '').localeCompare(String(second.id || ''));
}

const sortByPriorityThenId = (first: PrioritySortable, second: PrioritySortable) => {
    const idOrder = sortById(first, second);
    const firstPriority = readPriority(first);
    const secondPriority = readPriority(second);

    if (firstPriority === null && secondPriority === null) return idOrder;
    if (firstPriority === null) return 1;
    if (secondPriority === null) return -1;

    return (firstPriority - secondPriority) || idOrder;
}

export default sortByPriorityThenId;
